export const EVENT_NAME_PAGE_LOADED = 'candidate_list_displayed';
export const EVENT_NAME_SELECT_CANDIDATE = 'candidate_job_details_pressed';
export const EVENT_NAME_DOWNLOAD_DOCUMENT = 'attachment_download_pressed';
export const EVENT_NAME_EXPAND_DOCUMENT =
  'candidate_document_expanded_viewer_pressed';
export const EVENT_NAME_COLLAPSE_DOCUMENT =
  'candidate_document_contracted_viewer_pressed';

export const EVENT_NAME_DESKTOP_CLICKED_RESUME_IN_CANDIDATE_LIST =
  'resume_in_candidate_list_pressed';
export const EVENT_NAME_DESKTOP_CLICKED_COVER_LETTER_IN_CANDIDATE_LIST =
  'cover_letter_in_candidate_list_pressed';
export const EVENT_NAME_DESKTOP_SELECTION_CRITERIA_LIST_PRESSED =
  'selection_criteria_in_candidate_list_pressed';

export const EVENT_NAME_PREVIOUS_APPLICATIONS_IN_CANDIDATE_LIST_PRESSED =
  'previous_applications_in_candidate_list_pressed';

export const EVENT_NAME_CANDIDATE_JOB_STATUS_CHANGED_SUCCEEDED =
  'candidate_job_status_change_succeeded';
export const EVENT_NAME_BULK_ACTIONS_CHANGE_STATUS_SUCCEEDED =
  'bulk_actions_change_status_succeeded';

export const EVENT_NAME_CANDIDATE_DETAILS_EMAIL_PRESSED =
  'candidate_management_candidate_details_email_mailto_link_pressed';
export const EVENT_NAME_CANDIDATE_DETAILS_PHONE_TEL_LINK_PRESSED =
  'candidate_management_candidate_details_phone_tel_link_pressed';

export const EVENT_NAME_CANDIDATE_DETAILS_EMAIL_COPY_PRESSED =
  'candidate_management_candidate_details_email_copy_pressed';
export const EVENT_NAME_CANDIDATE_DETAILS_PHONE_COPY_PRESSED =
  'candidate_management_candidate_details_phone_copy_pressed';

export const EVENT_NAME_CANDIDATE_LIST_SORT_OPTION_PRESSED =
  'candidate_list_sort_option_pressed';

export const EVENT_NAME_VIEW_JOB_DETAILS_ACTIVE_JOB_PRESSED =
  'view_job_details_active_job_pressed';
export const EVENT_NAME_VIEW_JOB_DETAILS_INACTIVE_JOB_PRESSED =
  'view_job_details_inactive_job_pressed';
export const EVENT_NAME_VIEW_AD_PERFORMANCE_PRESSED =
  'job_actions_view_ad_performance_pressed';

// note events
export const EVENT_NAME_DELETE_NOTE_PRESSED = 'delete_note_pressed';
export const EVENT_NAME_NOTES_TAB_PRESSED = 'notes_tab_pressed';
export const EVENT_NAME_ADD_NOTE_PRESSED = 'add_note_pressed';
export const EVENT_NAME_NOTES_IN_CANDIDATE_LIST_PRESSED =
  'notes_in_candidate_list_pressed';

// hirer uploaded attachment events
export const EVENT_NAME_ADD_ATTACHMENT_PRESSED = 'add_attachment_pressed';
export const EVENT_NAME_CANDIDATE_DOCUMENTS_DELETE_PRESSED =
  'candidate_documents_delete_pressed';
export const EVENT_NAME_ATTACHMENT_UPLOAD_SUCCEEDED =
  'attachment_upload_succeeded';

// profile events
export const EVENT_NAME_PROFILE_TAB_PRESSED = 'profile_tab_pressed';
export const EVENT_NAME_MORE_QUESTIONS_CANDIDATE_LIST_PRESSED =
  'more_questions_in_candidate_list_pressed';

// previous applications events
export const EVENT_NAME_CLICKED_PREVIOUS_APPLICATIONS_TAB =
  'previous_applications_tab_pressed';

export const TRACKING_CANDIDATE_LIST = 'candidate list';
export const TRACKING_CANDIDATE_DETAILS = 'candidate details';

export type TrackingCurrentPage =
  | typeof TRACKING_CANDIDATE_LIST
  | typeof TRACKING_CANDIDATE_DETAILS;

export const TRACKING_PAGE_DATA_HOME = {
  siteSection: 'jobs',
  siteSubsection: 'candidate',
  isLoggedIn: true,
  currentPage: TRACKING_CANDIDATE_LIST,
};

export enum NOTIFICATION_TYPE {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
// email events
export const EVENT_NAME_SEND_EMAIL_PRESSED = 'send_email_pressed';
export const EVENT_NAME_SEND_EMAIL_SUCCEEDED = 'send_email_succeeded';
export const EVENT_NAME_BULK_ACTIONS_SEND_EMAIL_SUCCEEDED =
  'bulk_actions_send_email_succeeded';
export const EVENT_NAME_EMAIL_TAB_PRESSED = 'email_tab_pressed';
export const EVENT_NAME_EMAIL_CANDIDATE_LIST_PRESSED =
  'email_in_candidate_list_pressed';

// bulk action events
export const EVENT_NAME_BULK_ACTIONS_SELECT_ALL_PRESSED =
  'bulk_actions_select_all_pressed';
export const EVENT_NAME_BULK_ACTIONS_MOVE_TAB_PRESSED =
  'bulk_actions_move_tab_pressed';
export const EVENT_NAME_BULK_ACTIONS_EMAIL_TAB_PRESSED =
  'bulk_actions_email_tab_pressed';
export const EVENT_NAME_BULK_ACTION_CLEAR_SELECTED_PRESSED =
  'bulk_action_clear_selected_pressed';
export const EVENT_NAME_VIEW_APPLICATIONS_AFTER_BULK_MOVE_PRESSED =
  'view_applications_after_bulk_move_pressed';
export const EVENT_NAME_SHOW_MORE_CANDIDATES_IN_BULK_ACTION_PRESSED =
  'show_more_candidates_in_bulk_action_pressed';

// job action events
export const EVENT_NAME_JOB_ACTIONS_VIEW_AD_PRESSED =
  'job_actions_view_ad_pressed';
export const EVENT_NAME_JOB_ACTIONS_EDIT_AD_PRESSED =
  'job_actions_edit_ad_pressed';
export const EVENT_NAME_DOWNLOAD_CANDIDATES_LINK_PRESSED =
  'download_candidates_link_pressed';
export const EVENT_NAME_JOB_ACTIONS_VIEW_AD_INFORMATION_PRESSED =
  'job_actions_view_stats_pressed';
export const EVENT_NAME_JOB_ACTIONS_SHARE_PRESSED = 'job_actions_share_pressed';
export const EVENT_NAME_JOB_ACTIONS_REFRESH_PRESSED =
  'job_actions_refresh_pressed';
export const EVENT_NAME_JOB_ACTIONS_COPY_PRESSED = 'job_actions_copy_pressed';
export const EVENT_NAME_JOB_ACTIONS_EXPIRE_PRESSED =
  'job_actions_expire_pressed';
export const EVENT_NAME_JOB_ACTIONS_NOTIFICATIONS_SELF_PRESSED =
  'job_actions_notifications_self_pressed';
export const EVENT_JOB_ACTIONS_TEAM_ACCESS_PRESSED =
  'job_actions_team_access_pressed';

// team access
export const EVENT_NAME_MANAGE_NOTIFICATIONS_TEAM_ACCESS_SAVE_PRESSED =
  'manage_notifications_team_save_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_TEAM_ACCESS_NEXT_PRESSED =
  'manage_notifications_team_next_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_TEAM_ACCESS_CANCEL_PRESSED =
  'manage_notifications_team_cancel_btn_pressed';
export const EVENT_TEAM_EMAIL_SAVE =
  'manage_notifications_team_email_send_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_TEAM_ACCESS_BACK_PRESSED =
  'manage_notifications_team_email_back_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_ADD_TEAMMATES_PRESSED =
  'manage_notifications_add_teammates_btn_pressed';
// team access callout
export const EVENT_NAME_MANAGE_NOTIFICATIONS_ADD_TEAM_MEMBERS_PRESSED =
  'manage_notifications_add_team_members_now_link_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_REQUEST_ADD_TEAM_ACCESS_PRESSED =
  'manage_notifications_request_add_team_access_link_pressed';

// job notifications
export const EVENT_NAME_MANAGE_NOTIFICATIONS_SELF_SAVE_PRESSED =
  'manage_notifications_self_save_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_SELF_CANCEL_PRESSED =
  'manage_notifications_self_cancel_btn_pressed';
export const EVENT_NAME_MANAGE_NOTIFICATIONS_JOB_EXPIRED_RETURN_PRESSED =
  'manage_notifications_job_expired_return_btn_pressed';

// share job ad in social media & copy
export const EVENT_NAME_SOCIAL_SHARE_FACEBOOK_PRESSED =
  'social_share_facebook_link_pressed';
export const EVENT_NAME_SOCIAL_SHARE_TWITTER_PRESSED =
  'social_share_twitter_link_pressed';
export const EVENT_NAME_SOCIAL_SHARE_LINKEDIN_PRESSED =
  'social_share_linkedin_link_pressed';
export const EVENT_NAME_SOCIAL_SHARE_COPY_JOBAD_PRESSED =
  'social_share_copy_link_pressed';

// matched qualities events
export const EVENT_NAME_MATCHED_QUALITIES_VIEW_MORE_PRESSED =
  'matched_qualities_view_more_link_pressed';
export const EVENT_NAME_MATCHED_QUALITIES_VIEW_LESS_PRESSED =
  'matched_qualities_view_less_link_pressed';

// rating events
export const EVENT_NAME_CHANGED_RATING = 'change_rating_pressed';
export const EVENT_NAME_CLEARED_RATING = 'cleared_rating_pressed';
export const EVENT_NAME_RATING_IN_CANDIDATE_LIST_PRESSED =
  'rating_in_candidate_list_pressed';

// talent search/Recommended Candidates events
export const EVENT_TALENT_SEARCH_BUTTON_LINK_OUT_CLICKED =
  'candidate-management-talent-search-browse-profiles-btn-interacted';
export const EVENT_CANDIDATE_MANAGEMENT_TALENT_SEARCH_VIEW_RECOMMENDED_CANDIDATES_BTN_PRESSED =
  'candidate_management_talent_search_view_recommended_candidates_btn_pressed';

// beta experience
export const EVENT_NAME_TAB_OPT_OUT_PRESSED = 'new_site_tab_opt_out_pressed';

// document events
export const EVENT_NAME_CLICKED_RESUME_TAB = 'resume_tab_pressed';
export const EVENT_NAME_CLICKED_COVER_LETTER_TAB = 'cover_letter_tab_pressed';
export const EVENT_NAME_SELECTION_CRITERIA_TAB_PRESSED =
  'selection_criteria_tab_pressed';

// pagination events
export const EVENT_NAME_NUMBERED_PAGE_PRESSED =
  'pagination_numbered_page_btn_pressed';
export const EVENT_NAME_CLICKED_NEXT_PAGE_BUTTON =
  'pagination-next-page-btn-interacted';
export const EVENT_NAME_CLICKED_PREVIOUS_PAGE_BUTTON =
  'pagination-previous-page-btn-interacted';
export const EVENT_NAME_SUFFIX_LAST_PAGE = '|last_page_pressed';

// filter events
export const EVENT_NAME_FILTERS_INTERACTED = 'filters_pressed';
export const EVENT_NAME_CLEAR_FILTERS_BUTTON_PRESSED = 'clear_filters_pressed';
export const EVENT_NAME_PARENT_FILTER_INTERACTED_ON =
  'parent_filter_on_pressed';
export const EVENT_NAME_PARENT_FILTER_OFF_PRESSED = 'parent_filter_off_pressed';
export const EVENT_NAME_MUST_HAVE_FILTER_INTERACTED = 'toggle_pressed';

// job tabs
export const EVENT_NAME_CANDIDATE_LIST_TAB_PRESSED =
  'candidate_list_tab_pressed';
export const EVENT_NAME_CLICKED_HIRER_ACTIVITY_LIST_TAB =
  'activity_log_tab_pressed';
export const EVENT_NAME_RECOMMENDED_CANDIDATES_TAB_PRESSED =
  'recommended_candidates_tab_pressed';

// hirer activity
export const EVENT_NAME_ACTIVITY_LOG_NOTE_PRESSED = 'activity_log_note_pressed';
export const EVENT_NAME_ACTIVITY_LOG_LOAD_MORE_PRESSED =
  'activity_log_load_more_btn_pressed';
export const EVENT_NAME_ACTIVITY_LOG_REFRESH_TO_VIEW_PRESSED =
  'activity_log_refresh_to_view_pressed';

// data retention
export const LINK_NAME_DATA_RETENTION_CANDIDATES_HIDDEN =
  'data_retention_candidates_hidden';
export const LINK_NAME_DATA_RETENTION_SHOW_CANDIDATES =
  'data_retention_show_candidates';

// generic page notifications
export const EVENT_NOTIFICATION_DISPLAYED = 'notification_displayed';
export const EVENT_NOTIFICATION_PRESSED = 'notification_pressed';

// charged per qualified applicants
export const EVENT_NAME_PPA_BILLABLE_APPLICANTS_DEFINITION_PRESSED =
  'ppa_billable_applicants_definition_pressed';

// candidate card status
export const EVENT_NAME_CANDIDATE_CARD_SIZE_CHANGE_PRESSED =
  'candidate_card_size_change_pressed';

export const EVENT_NAME_ALERT_DISMISS_PRESSED = 'alert_dismiss_pressed';

// seek recruiter network
export const EVENT_NAME_SRN_BANNER_DISMISS_PRESSED =
  'srn_banner_dismiss_pressed';
export const EVENT_NAME_SRN_BUTTON_PRESSED = 'srn_banner_button_pressed';
export const BANNER_DISPLAYED = 'candidate_management_banner_displayed';

// Freemium
export const EVENT_NAME_FREEMIUM_BUTTON_PRESSED = 'job_upgrade_button_pressed';
export const EVENT_NAME_FREEMIUM_BUTTON_DISPLAYED = 'job_upgrade_button_viewed';
